@if (data$ | async; as data) {
<div [ngClass]="isSuccess ? 'd-none' : 'forgot-password-container'">
  <div class="forgot-password-wrapper">
    <div class="forgot-password-heading">
      @if (!asmEnabled) {
      <a [routerLink]="['/login']" (click)="goToLogin(false)" rel="noopenner noreferrer">
        <ng-container *ngTemplateOutlet="innerBackLinkTemplate"></ng-container>
      </a>
      } @else {
       <a [routerLink]="['/login']" [queryParams]="{ asm: true }" (click)="goToLogin(true)" rel="noopenner noreferrer">
        <ng-container *ngTemplateOutlet="innerBackLinkTemplate"></ng-container>
      </a>
      }
      <ng-template #innerBackLinkTemplate>
        <i class="material-icons back-icon">keyboard_arrow_left</i>
        {{ 'forgotPassword.goBack' | cxTranslate }}
      </ng-template>
      <h1>{{ 'forgotPassword.heading' | cxTranslate }}</h1>
      <p>{{ 'forgotPassword.message' | cxTranslate }}</p>
    </div>
    <div class="forgot-password-form">
      @if (err && !!errorMsg) {
      <div class="forgot-error alert alert-danger alert-dismissible collapse show" role="alert">
        {{ errorMsg }}
        <button type="button" class="close" (click)="clearErrorMessage()" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      }
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
        <mat-form-field appearance="outline" class="w-100 mt-3" [hideRequiredMarker]="true">
          <mat-label>{{ 'forgotPassword.email' | cxTranslate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'forgotPassword.email' | cxTranslate }}"
            formControlName="email"
            id="emailInput"
            (change)="emailChange($event, forgotPasswordForm.invalid)"
          />
          @if (forgotPasswordForm.invalid && (forgotPasswordForm.dirty || forgotPasswordForm.touched)) {
          <mat-error>
            {{ 'forgotPassword.errorMessage' | cxTranslate }}
          </mat-error>
          }
        </mat-form-field>
        <div class="forgot-password-button">
          <button mat-button class="btn btn-primary" [class.disabled]="isDisabled" [disabled]="isDisabled">
            {{ 'forgotPassword.resetButton' | cxTranslate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div [ngClass]="isSuccess ? 'forgot-password-success' : 'd-none'">
  <h1>{{ 'forgotPassword.success' | cxTranslate }}</h1>
  <p>{{ 'forgotPassword.successMessage' | cxTranslate : { email: forgotPasswordForm.controls.email.value } }}</p>
  <div class="forgot-password-success-button">
    <button mat-button class="btn-primary" [routerLink]="['/login']">
      {{ 'forgotPassword.successButton' | cxTranslate }}
    </button>
  </div>
</div>
}
